import auth from '@/middleware/auth'
import { RESOURCE_JOBS, RESOURCE_JOBS_REPORTS } from '@/shared/constants/resources'

export default [
  {
    path: '/jobs-reports',
    meta: {
      middleware: [auth],
      resource: RESOURCE_JOBS,
      headerVisible: false,
    },
    name: 'jobsGeneralReports',
    component: () => import('@/views/jobs-general-reports/List.vue'),
  },
]
